<template>
  <div class="sidebar-header">
    <BaseTitle tag="h2">{{ title }}</BaseTitle>
    <router-link class="sidebar-header__link" to="/profile" @mouseenter.native="handleMouseEnter" @mouseleave.native="handleMouseLeave">
      <BaseIcon tag="span" type="gears" />
      <ElementTooltip text="Manage MySpace" position="bottom-right" :active="showTooltip" />
    </router-link>
  </div>
</template>

<script>
import BaseTitle from '@base/BaseTitle'
import BaseIcon from '@base/BaseIcon'
import ElementTooltip from '@elements/ElementTooltip'

export default {
  name: 'TheSidebarHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  components: {
    BaseTitle,
    BaseIcon,
    ElementTooltip
  },
  data () {
    return {
      showTooltip: false
    }
  },
  methods: {
    handleMouseEnter () {
      this.showTooltip = true
    },
    handleMouseLeave () {
      this.showTooltip = false
    }
  }
}
</script>

<style lang="scss">
  .sidebar-header{
    padding: layout("spacing");
    background-color: colors("topbar");
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title{
      font-weight: font-weights("medium");
      color: white;
      line-height: 1;
    }

    &__link{
      @include hover{
        .icon-gears{
          color: tint(colors("topbar"), 20%);
        }
      }

      position: relative;
      display: block;
      font-size: 2.4rem;

      .icon-gears{
        @include add-transition;
        color: white;
        font-size: 2.4rem;
      }
    }

  }
</style>
